<template>
  <section class="container">
    <h1>Add New Grape</h1>
    <div class="message-wrap" v-if="!signedIn">
      <p>You need to be signed in to submit a grape, please <router-link to="/account">click here to log in or sign up</router-link>.</p>
    </div>
    <div v-if="signedIn">
      <GrapeForm formType="new" />
    </div>
  </section>

</template>

<script>
  import firebase from 'firebase'
  import GrapeForm from './GrapeForm.vue'

  export default {
    name: 'new-grape',
    data () {
      return {
        signedIn: false
      }
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.signedIn = true
        } else {
          vm.signedIn = false
        }
      })
    },
    methods: {
    },
    mounted () {
    },
    components: {
      GrapeForm
    }
  };
</script>

<style scoped>
  section {
    height: 100vh;
  }
  .message-wrap p {
    font-size: 1.2em;
    margin: 50px 0 0;
  }
  .message-wrap p a {
    text-decoration: none;
    color: #36a731;
  }
</style>


// WEBPACK FOOTER //
// src/components/NewGrape.vue